import { EmptyStatePage, type StepCard, StepCardsRow } from "@/components/application/empty-state-page";

const STEPS: StepCard[] = [
  {
    icon: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m2-.611-1.223.68c-.284.157-.425.236-.575.267a.998.998 0 0 1-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.942c0-.343 0-.514.05-.667a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111c.284-.158.425-.237.576-.267a1 1 0 0 1 .402 0c.15.03.292.11.576.267l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.153.05.324.05.667V12.5m-13.5-8 9 5M16 18l2 2 4-4",
    title: "Approve, reject or ignore requests",
    sub: "Every open request across active collaborations lands here for a decision",
  },
  {
    icon: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1 11 2 2 4.5-4.5M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6Z",
    title: "Keep track of what’s pending",
    sub: "Pending, approved and shipped stay counted as you work through them",
  },
  {
    icon: "M12 17a5 5 0 1 0 10 0 5 5 0 0 0-10 0Zm0 0c0-1.126.372-2.165 1-3V5m-1 12c0 .825.2 1.604.554 2.29-.842.712-2.788 1.21-5.054 1.21-3.038 0-5.5-.895-5.5-2V5m11 0c0 1.105-2.462 2-5.5 2S2 6.105 2 5m11 0c0-1.105-2.462-2-5.5-2S2 3.895 2 5m0 9c0 1.105 2.462 2 5.5 2 2.189 0 4.08-.465 4.965-1.138M13 9.5c0 1.105-2.462 2-5.5 2S2 10.605 2 9.5",
    title: "Allocate a monthly amount",
    sub: "Set the cap per month, so you never approve more than you can send",
  },
];

/** Full-bleed first-run empty state — shown only when the workspace has no sample requests at all. */
export function SampleRequestsFirstRun() {
  return (
    <EmptyStatePage
      eyebrow="Sample Requests"
      headline="Know who’s worth a sample"
      subline={[
        "Every request arrives with the creator’s GMV history, their past collabs and any safety flags, so you approve on the evidence rather than on a hunch.",
        "Requests appear here as soon as creators start asking.",
      ]}
      measureCh={46}
      contentGapClassName="gap-12"
      portraitSrc="/empty-states/portrait-sample-requests.webp"
      portraitMaskLeft="28%"
      portraitMaskBottom={null}
      portraitClassName="top-1/2 -right-16 h-[105%] w-auto -translate-y-1/2 opacity-55"
      device={<StepCardsRow steps={STEPS} />}
    />
  );
}
